/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { yearShortToCropYearShort, OLAPTransformerResult } from "../../../shared";
import Highcharts from "highcharts";
import { TableProps } from "../../../components/Table";

const CATEGORIES_AXIS = "calendar.default";
const SERIES_AXIS = "commodities.default";

export function useChart(data: OLAPTransformerResult | null, orderedIds: any[]): TableProps | undefined {
  const [state, setState] = useState<TableProps | undefined>();
  const colKey = `${CATEGORIES_AXIS}.name`;
  const mapperColors = useMemo(() => {
    return new Map<string, [string | null, string | null]>();
  }, []);
  const categories = useMemo(
    () =>
      data?.columns.map((x) => {
        const yearName = x.headers.find((h) => h.id === colKey)?.name;
        const year = Number(yearName);
        const label = `${yearShortToCropYearShort(year - 1)} vs. ${yearShortToCropYearShort(year)}*`;
        return [yearName, label] as [string, string];
      }) || [],
    [data],
  );

  useEffect(() => {
    if (data) { 
      const rows = data?.rows.sort((a,b) => {
        const indexA = orderedIds.indexOf(a.selection[SERIES_AXIS]);
        const indexB = orderedIds.indexOf(b.selection[SERIES_AXIS]);
        return indexA - indexB;
      }).map((x) => {
        const records = {
          Commodity: x.attributes[`${SERIES_AXIS}.name`][9] || "",
        };
        for (const point of x.points) {
          const col = point.attributes ? point.attributes[colKey] : "";
          const value = (point['change'] || 0);
          const displayValue = value ? `${Highcharts.numberFormat(value, 1)}%` : "N/A";
          records[col] = displayValue;
          let color: [string | null, string | null] = [null, null];

          if (value < -1) {
            color = [null, "#ff8a65"];
          }
          if (value < -5) {
            color = ["white", "#ef5350"];
          }
          if (value > 1) {
            color = [null, "#a5d6a7"];
          }
          if (value > 5) {
            color = ["white", "#66bb6a"];
          }
          mapperColors.set(displayValue, color);
        }
        return records;
      });
      const result: TableProps = {
        columns: [["Commodity", "Commodities"]].concat(categories).map(([field, headerName]) => ({
          headerName,
          field,
          resizable: true,
          cellStyle: function(params) {
            if (mapperColors.has(params.value)) {
              const [color, backgroundColor] = mapperColors.get(params.value)!;
              return { color, backgroundColor, textAlign: 'center' };
            }
            return undefined;
          },
        })),
        rows,
      };

      setState(result);
    }
  }, [data]);
  return state;
}
